import { render, staticRenderFns } from "./ProfileSecretaire.vue?vue&type=template&id=6d2fa102&"
import script from "./ProfileSecretaire.vue?vue&type=script&lang=js&"
export * from "./ProfileSecretaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports